"use client";

import { ValueIterationVisualisation } from "@/app/(articles)/(learn)/solved/ValueIterationVisualisation.js";
import { useOnClient } from "@rosette/web_utils/src/useOnClient.js";


export function ValueIterationWidget() {
    const onClient = useOnClient();
    return (
        <div className="h-64 md:h-80">
            {onClient && (
                <ValueIterationVisualisation />
            )}
        </div>
    );
}
